import { useState, useEffect } from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, Button, Grid, AppBar, Tabs, Tab } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { actulizaTerrestreAction, obtenerTerrestreAllAction, obtenerCatalogoProveedorTerrestre, openModalEditarPaqueteAction } from "./../../../ducks/proveedorTerrestreDuck"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import ControllerEditor from "./../ControlledEditor"

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const useCatalogoPrveedoresTerrestres = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorTerrestre()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    nombrePaquete: yup
        .string("Ingrese nombre de paquete")
        .required("Es requerido"),
})

const initialValues = {
    monto: 0,
    nombrePaquete: "",

}

const FPAroveedoresTerrestres = () => {
    const [value, setValue] = useState(0)
    const [idProveedor, setIdProveedor] = useState(0)
    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui el itinerario</strong></p>')
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui lo que incluye</strong></p>')
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
    useCatalogoPrveedoresTerrestres()
    const { catalogoTerrestre, paqueteSelect, openEditPaquete } = useSelector(store => store.proveedorTerrestre)
    const open = openEditPaquete
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FormularioReservaStyle()
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })

    useEffect(() => {
        setValue(2)
        if (paqueteSelect?.IdPaqueteProveedorTerrestre > 0) {
            formik.setFieldValue("nombrePaquete", paqueteSelect.Nombre)
            formik.setFieldValue("monto", paqueteSelect.PrecioNeto)
            setTipoMoneda(paqueteSelect.Moneda?.id_moneda)
            setIdProveedor(paqueteSelect.Proveedor?.IdProveedor)
            setItenerario(paqueteSelect.Itinerario)
            setIncluye(paqueteSelect.Incluye)
            setNoIncluye(paqueteSelect.NoIncluye)
            setValue(0)
        }
    }, [paqueteSelect])


    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const onItinerarioValue = (value) => {
        setItenerario(value)
    }
    const onIncluyeValue = (value) => {
        setIncluye(value)
    }
    const onNoIncluyeValue = (value) => {
        setNoIncluye(value)
    }
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const handleClose = () => {
        dispatch(openModalEditarPaqueteAction({ open: false, paquete: {} }))
        setTipoMoneda(0)
        setValue(0)
        setItenerario('<p><strong>Escribe aqui el itinerario</strong></p>')
        setIncluye('<p><strong>Escribe aqui lo que incluye</strong></p>')
        setNoIncluye('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
        formik.resetForm(initialValues)
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const onSave = (values) => {
        if (tipoMoneda === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        if (idProveedor === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una proveedor valido",
            })
            return null
        }
        dispatch(onLoadAnction({ message: '' }))
        dispatch(actulizaTerrestreAction({
            IdPaqueteProveedorTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
            ClavePaquete: "No aplica",
            IdMoneda: tipoMoneda,
            IdProveedor: idProveedor,
            Itinerario: itinerario,
            Nombre: values?.nombrePaquete,
            PrecioNeto: values?.monto,
            Incluye: incluye,
            NoIncluye: noIncluye
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerTerrestreAllAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    return (
        <div>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo terrestre`}
                />

                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={3}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoProveedor">Proveedor terrestre</InputLabel>
                                <Select
                                    labelId="lTipoProveedor"
                                    id="STipoProveedor"
                                    name="proveedor"
                                    value={idProveedor}
                                    onChange={handleSelecProveedor}
                                    label="Proveedor terrestre"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoTerrestre.map((item, index) => (
                                        <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                            {item.RazonSocial}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                required
                                id="input-Nombre"
                                label="Nombre paquete"
                                type="text"
                                variant="outlined"
                                name="nombrePaquete"
                                value={formik.values.nombrePaquete}
                                onChange={formik.handleChange}
                                error={formik.touched.nombrePaquete && Boolean(formik.errors.nombrePaquete)}
                                helperText={formik.touched.nombrePaquete && formik.errors.nombrePaquete}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                required
                                id="input-Monto"
                                label="Monto"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                    <Grid container className={classes.containerSpacing}>

                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="Itinerario" {...a11yProps(0)} />
                                <Tab label="Incluye" {...a11yProps(1)} />
                                <Tab label="No Incluye" {...a11yProps(2)} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <ControllerEditor onValue={onItinerarioValue} content={itinerario} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <ControllerEditor onValue={onIncluyeValue} content={incluye} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <ControllerEditor onValue={onNoIncluyeValue} content={noIncluye} />
                        </TabPanel>

                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}
export default FPAroveedoresTerrestres